import React from 'react';
import DOMPurify from 'dompurify';
import styles from './Contact.module.css';

const StepFive = ({ formData, handleInputChange, handleCheckboxChange, errors }) => {

  const handleSanitizedInputChange = (inputName, value) => {
    const sanitizedValue = DOMPurify.sanitize(value);
    handleInputChange({ target: { name: inputName, value: sanitizedValue } });
  };

  const handleKeyDown = (event, value, inputName) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleSanitizedInputChange(inputName, value);
    }
  };

  return (
    <div className={styles.step}>
      <h2>Step 5: Is Stair Railing Required?</h2>
      <div className={styles.toggle}>
        <button
          type="button"
          className={`${styles.toggleButton} ${!formData.stairRailingRequired ? styles.active : ''}`}
          onClick={() => handleCheckboxChange({ target: { name: 'stairRailingRequired', checked: false } })}
          onKeyDown={(event) => event.key === 'Enter' && handleCheckboxChange({ target: { name: 'stairRailingRequired', checked: false } })}
          aria-pressed={!formData.stairRailingRequired}
          tabIndex={0}
        >
          No
        </button>
        <button
          type="button"
          className={`${styles.toggleButton} ${formData.stairRailingRequired ? styles.active : ''}`}
          onClick={() => handleCheckboxChange({ target: { name: 'stairRailingRequired', checked: true } })}
          onKeyDown={(event) => event.key === 'Enter' && handleCheckboxChange({ target: { name: 'stairRailingRequired', checked: true } })}
          aria-pressed={formData.stairRailingRequired}
          tabIndex={0}
        >
          Yes
        </button>
      </div>

      {formData.stairRailingRequired && (
        <div className={styles.stairRailingOptions}>
          <div className={styles.toggleGroup}>
            <div className={styles.toggle}>
              <button
                type="button"
                className={`${styles.toggleButton} ${formData.stairRailingSide === 'One Side' ? styles.active : ''}`}
                onClick={() => handleSanitizedInputChange('stairRailingSide', 'One Side')}
                onKeyDown={(event) => handleKeyDown(event, 'One Side', 'stairRailingSide')}
                aria-pressed={formData.stairRailingSide === 'One Side'}
                tabIndex={0}
              >
                One Side
              </button>
              <button
                type="button"
                className={`${styles.toggleButton} ${formData.stairRailingSide === 'Both Sides' ? styles.active : ''}`}
                onClick={() => handleSanitizedInputChange('stairRailingSide', 'Both Sides')}
                onKeyDown={(event) => handleKeyDown(event, 'Both Sides', 'stairRailingSide')}
                aria-pressed={formData.stairRailingSide === 'Both Sides'}
                tabIndex={0}
              >
                Both Sides
              </button>
            </div>
          </div>

          {formData.stairRailingSide && (
            <div className={styles.toggleGroup}>
              <div className={styles.toggle}>
                <button
                  type="button"
                  className={`${styles.toggleButton} ${formData.stairRailingType === 'Glass' ? styles.active : ''}`}
                  onClick={() => handleSanitizedInputChange('stairRailingType', 'Glass')}
                  onKeyDown={(event) => handleKeyDown(event, 'Glass', 'stairRailingType')}
                  aria-pressed={formData.stairRailingType === 'Glass'}
                  tabIndex={0}
                >
                  Glass
                </button>
                <button
                  type="button"
                  className={`${styles.toggleButton} ${formData.stairRailingType === 'Picket' ? styles.active : ''}`}
                  onClick={() => handleSanitizedInputChange('stairRailingType', 'Picket')}
                  onKeyDown={(event) => handleKeyDown(event, 'Picket', 'stairRailingType')}
                  aria-pressed={formData.stairRailingType === 'Picket'}
                  tabIndex={0}
                >
                  Picket
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {errors.stairRailingSide && <p className={styles.error}>{errors.stairRailingSide}</p>}
    </div>
  );
};

export default StepFive;